(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-sfl-chart"] && !Shopify.designMode) return;
  try {
    
  const englishEyeDiameters = [
    0.6, 1, 1.125, 1.25, 1.5, 2, 0.7, 0.9, 1, 1.1, 1.2, 0.375, 0.5, 0.625, 0.75, 0.875, 0.625, 1, 0.625, 0.75, 0.5,
  ];
  const englishRopeDiameters = [
    '1/4',
    '1/2',
    '1/2',
    '5/8',
    '5/8',
    '5/8',
    '3/8',
    '3/8',
    '1/2',
    '1/2',
    '1/2',
    '1/4',
    '1/4',
    '3/8',
    '3/8',
    '3/8',
    '1/2',
    '1/2',
    '3/8',
    '3/8',
    '1/4',
  ];
  const metricRopeDiameters = [8, 12, 14, 16, 16, 16, 10, 10, 12, 14, 14, 6, 6, 10, 10, 10, 12, 12, 10, 10, 6];

  function convertInchesToMM(inches) {
    const val = inches * 25.4;
    return Math.round(val);
  }

  function updateRows(getEyeText, getRopeText) {
    const rows = document.querySelectorAll('.pform-info-table tr');

    if (!rows || rows.length === 0) {
      return;
    }

    for (let i = 1; i < rows.length; i++) {
      // skip header row at index 0
      const cells = rows[i].children;

      if (cells && cells.length >= 3) {
        cells[1].textContent = getEyeText(i - 1);
        cells[2].textContent = getRopeText(i - 1);
      }
    }
  }

  function setMetric() {
    updateRows(
      (idx) => `${convertInchesToMM(englishEyeDiameters[idx])} mm`,
      (idx) => `${metricRopeDiameters[idx]} mm`
    );
  }

  function setEnglish() {
    updateRows(
      (idx) => `${englishEyeDiameters[idx]}″`,
      (idx) => `${englishRopeDiameters[idx]}″`
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    const englishBtn = document.getElementById('english_sfl');
    const metricBtn = document.getElementById('metric_sfl');

    const setPressed = (isEnglish) => {
      if (englishBtn) {
        englishBtn.setAttribute('aria-pressed', String(isEnglish));
      }
      
      if (metricBtn) {
        metricBtn.setAttribute('aria-pressed', String(!isEnglish));
      }
    };

    if (englishBtn) {
      englishBtn.addEventListener('click', function (e) {
        e.preventDefault();
        setEnglish();
        setPressed(true);
      });
    }

    if (metricBtn) {
      metricBtn.addEventListener('click', function (e) {
        e.preventDefault();
        setMetric();
        setPressed(false);
      });
    }

    setEnglish();
    setPressed(true);
  });

  } catch(e) { console.error(e); }
})();
})();
